import {
  TaskStatus,
  TaskType,
  type GetAllTasksParams,
  type TaskResponse,
} from "api/model";
import type { getAllTasksResponse } from "api/tasks/tasks";

import { getTaskLocationUuid } from "./orthoUpload";
import { getPlotTaskOrthoId } from "./orthoPlotTasks";

export const rawImageUploadTasksParams: GetAllTasksParams = {
  task_type: [TaskType.raw_image_upload],
};

export const orthoCreationTasksParams: GetAllTasksParams = {
  task_type: [TaskType.ortho_creation],
};

export const analyzeEmergenceTasksParams: GetAllTasksParams = {
  task_type: [TaskType.analyze_emergence],
};

export const analyzeCanopyTasksParams: GetAllTasksParams = {
  task_type: [TaskType.analyze_canopy_cover],
};

export const snipOrthoTasksParams: GetAllTasksParams = {
  task_type: [TaskType.snip_ortho],
};

export const TASK_POLL_INTERVAL_MS = 5000;

const defaultTasks: TaskResponse[] = [];

/** `GET /tasks` returns every location's tasks; keep the ones whose summary names this location. */
export const selectLocationTasks = (
  res: getAllTasksResponse | undefined,
  locationUuid: string,
): TaskResponse[] =>
  res?.status === 200
    ? res.data.filter((task) => getTaskLocationUuid(task) === locationUuid)
    : defaultTasks;

/** Analyze tasks name an ortho, not a location; keep the ones for these orthos. */
export const selectOrthoPlotTasks = (
  res: getAllTasksResponse | undefined,
  orthoIds: ReadonlySet<number>,
): TaskResponse[] =>
  res?.status === 200
    ? res.data.filter((task) => {
        const orthoId = getPlotTaskOrthoId(task);
        return orthoId != null && orthoIds.has(orthoId);
      })
    : defaultTasks;

export const hasInFlightTask = (tasks: readonly TaskResponse[]): boolean =>
  tasks.some(
    (task) =>
      task.status === TaskStatus.waiting ||
      task.status === TaskStatus.pending ||
      task.status === TaskStatus.processing,
  );
